// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609030404/js/" + chunkId + "." + {"44":"3f3f2a9d","225":"9d5059e2","481":"e386e476","486":"eea0b307","770":"fdbea98f"}[chunkId] + ".0.4146768297223865.chunk.js";
};